import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {selectComicsForChapter} from '../../../store/reducers';
import {getCurrentLang} from '../../../utils/i18n';

const GoChapterButton = props => {
    const {t} = useTranslation();
    const comic = useSelector(state =>
        selectComicsForChapter(state, props.chapter?.id),
    );

    const user = useSelector(state => state.user);
    const idp = user && user.idp;

    const trackNext = () => {
        if (props.trackNext) {
            window.turner_metadata.trackAction.push({
                type: 'interaction',
                data: {
                    interaction: 'comic|next chapter',
                    domain: 'cnplus.com',
                    brand: 'cartoon network',
                    server: 'cnplus',
                    platform: 'web',
                    region: 'latam',
                    country:
                        user && user.countryIsoCode && user.countryName
                            ? `${user.countryIsoCode.toLowerCase()}|${
                                  user.countryName
                              }`
                            : 'not loaded',
                    interactionevent: '1',
                    authstate:
                        user && user.jwtToken
                            ? 'authenticated'
                            : 'unauthenticated',
                    mvpd: idp || 'idp not loaded',
                    userlang: getCurrentLang(),
                    franchise: comic.show,
                    contenttype: 'comics',
                    contenttitle: comic.title,
                    chapter_number: String(props.chapter.number),
                    english_name: comic.englishTitle.toLowerCase(),
                    nextchapter_event: '1',
                },
            });
        }
    };

    return (
        <Container
            to={`/comics/${comic?.friendlyName}/${props.chapter?.number}`}
            replace={props.replace}
            onClick={trackNext}
        >
            <TitleText>
                {t('comics.gotoChapter').replace(
                    '{chapter}',
                    props.chapter?.number.toString() || '1',
                )}
            </TitleText>
        </Container>
    );
};

const Container = styled(Link)`
    display: flex;
    min-width: 171px;
    height: 44px;
    padding: 0px 15px;
    overflow: hidden;
    border-radius: 6px;
    align-self: center;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #f55a86 0%, #ec098c 100%);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.35);
    border-radius: 6px;
    margin-top: 32px;
    color: transparent;
    flex-shrink: 0;
`;

const TitleText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    color: white;
`;

export default GoChapterButton;
